export const ID_COLLECTION = 'COLLECTION';
export const ID_ADD_TO_COLLECTION_MODAL = 'ADD_TO_COLLECTION_MODAL';
export const ID_STORAGES_BROWSER = 'STORAGES_BROWSER';
export const ID_UPLOAD_TO_COLLECTION_MODAL = 'UPLOAD_TO_COLLECTION_MODAL';
export const ID_PROJECT_COLLECTION_LOCATION = 'PROJECT_COLLECTION_LOCATION';
export const ID_ADD_SUBCLIP_TO_COLLECTION = 'ADD_SUBCLIP_TO_COLLECTION';
export const ID_SELECT_COLLECTION = 'ID_SELECT_COLLECTION';

export const treeReducer = {
  [ID_COLLECTION]: 'collectionsTree',
  [ID_ADD_TO_COLLECTION_MODAL]: 'collectionsTreeAddToCollection',
  [ID_STORAGES_BROWSER]: 'storagesTree',
  [ID_UPLOAD_TO_COLLECTION_MODAL]: 'collectionsTreeUploadToCollection',
  [ID_PROJECT_COLLECTION_LOCATION]: 'projectParentTree',
  [ID_ADD_SUBCLIP_TO_COLLECTION]: 'collectionsTreeAddSubclipToCollection',
  [ID_SELECT_COLLECTION]: 'collectionsTreeSelectCollection',
} as const;
